'use client'

import * as React from 'react'
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog'

import './alert-dialog.css'
/* Root */
export function AlertDialog(props) {
  return (
    <AlertDialogPrimitive.Root
      data-slot="alert-dialog"
      {...props}
    />
  )
}

/* Trigger */
export function AlertDialogTrigger(props) {
  return (
    <AlertDialogPrimitive.Trigger
      data-slot="alert-dialog-trigger"
      {...props}
    />
  )
}

/* Portal */
export function AlertDialogPortal(props) {
  return (
    <AlertDialogPrimitive.Portal
      data-slot="alert-dialog-portal"
      {...props}
    />
  )
}

/* Overlay */
export function AlertDialogOverlay({ className = '', ...props }) {
  return (
    <AlertDialogPrimitive.Overlay
      data-slot="alert-dialog-overlay"
      className={`alert-dialog-overlay ${className}`}
      {...props}
    />
  )
}

/* Content */
export function AlertDialogContent({ className = '', ...props }) {
  return (
    <AlertDialogPortal>
      <AlertDialogOverlay />
      <AlertDialogPrimitive.Content
        data-slot="alert-dialog-content"
        className={`alert-dialog-content ${className}`}
        {...props}
      />
    </AlertDialogPortal>
  )
}

/* Header */
export function AlertDialogHeader({ className = '', ...props }) {
  return (
    <div
      data-slot="alert-dialog-header"
      className={`alert-dialog-header ${className}`}
      {...props}
    />
  )
}

/* Footer */
export function AlertDialogFooter({ className = '', ...props }) {
  return (
    <div
      data-slot="alert-dialog-footer"
      className={`alert-dialog-footer ${className}`}
      {...props}
    />
  )
}

/* Title */
export function AlertDialogTitle({ className = '', ...props }) {
  return (
    <AlertDialogPrimitive.Title
      data-slot="alert-dialog-title"
      className={`alert-dialog-title ${className}`}
      {...props}
    />
  )
}

/* Description */
export function AlertDialogDescription({ className = '', ...props }) {
  return (
    <AlertDialogPrimitive.Description
      data-slot="alert-dialog-description"
      className={`alert-dialog-description ${className}`}
      {...props}
    />
  )
}

/* Action (Primary button) */
export function AlertDialogAction({ className = '', ...props }) {
  return (
    <AlertDialogPrimitive.Action
      className={`btn btn-primary ${className}`}
      {...props}
    />
  )
}

/* Cancel (Outline button) */
export function AlertDialogCancel({ className = '', ...props }) {
  return (
    <AlertDialogPrimitive.Cancel
      className={`btn btn-outline ${className}`}
      {...props}
    />
  )
}
